module.exports = __webpack_public_path__ + "assets/img/btn-download-google-play-d1e913de.png";